import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AlertHttpService } from '../../../../../core/alerts';

@Component({
  selector: 'kt-oi-dialogs',
  templateUrl: './oi-dialogs.component.html',
  styleUrls: ['./oi-dialogs.component.scss']
})
export class OiDialogsComponent implements OnInit {

	selectedReason;
  otherBox;
  reasons = [];

  constructor(public dialogRef: MatDialogRef<OiDialogsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  				        private http: AlertHttpService) { }

  ngOnInit() {
	this.getReasons();
  }

  getReasons() {
	this.http.getIssueReason()
	.subscribe(reasons => {
		this.reasons = reasons;
	});
  }

  onOk() {
	let clearObj = {
		machine_id: this.data.machine_id,
		issue_code: this.data.log_code,
		issue_msg: this.data.log_msg,
		reason: this.selectedReason
	};
	if (this.selectedReason === 'other') {
		clearObj.reason = this.otherBox;
		this.dialogRef.close({success: true, clearObj});
	} else {
		this.dialogRef.close({success: true, clearObj});
	}
  }

}
